import { CUSTOM_FIELDS_VALUE_SOURCE } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';

import {
  CUSTOM_FIELD_TARGET_LABEL,
  CUSTOM_FIELD_TARGET_ORDER,
  UNKNOWN_CUSTOM_FIELD_TARGET_LABEL,
} from 'constants/customFieldTargets';

const isManualEnabledDefinition = definition =>
  !!definition?.isEnabled && definition?.valueSource?.type === CUSTOM_FIELDS_VALUE_SOURCE.MANUAL;

const getDefinitionTargetLabel = target =>
  CUSTOM_FIELD_TARGET_LABEL[target] ?? UNKNOWN_CUSTOM_FIELD_TARGET_LABEL;

const getTargetOrderIndex = target => {
  const index = CUSTOM_FIELD_TARGET_ORDER.indexOf(target);

  return index === -1 ? CUSTOM_FIELD_TARGET_ORDER.length : index;
};

export const buildCustomFieldDefinitionOptions = definitions =>
  (definitions ?? [])
    .filter(isManualEnabledDefinition)
    .map(definition => ({
      name: definition.name,
      value: definition.id,
      section: getDefinitionTargetLabel(definition.target),
      target: definition.target,
    }))
    .sort((a, b) => {
      const targetDiff = getTargetOrderIndex(a.target) - getTargetOrderIndex(b.target);

      if (targetDiff !== 0) {
        return targetDiff;
      }

      return a.name.localeCompare(b.name);
    });

export const groupOptionBySection = option => option.section;
